/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
// methods for the User model

import { normalize } from "utils/capitalize";
import getBase64Details from "utils/getBase64Details";

export const isVmsEnabled = (user) => !!user?.event_is_vms_enabled;

export const isUserBookingHisFlight = (user, flight_type) => {
  const flightType = getFlightType(flight_type || user.flight_type);
  const isFlightFilledByUser = isFlightProvidedByUser(flightType);
  // This field `is_self_booking_flight` is being omitted by backend.
  const isUserBookingFlight =
    user?.is_self_booking_flight === undefined
      ? true
      : user.is_self_booking_flight;
  return isUserBookingFlight && isFlightFilledByUser;
};

export const isFlightProvidedByAdmin = (flight_type) => {
  const flightType = getFlightType(flight_type);
  return flightType === 1 || flightType === "pr";
};
export const isFlightProvidedByUser = (flight_type) => {
  const flightType = getFlightType(flight_type);
  return flightType === 2 || flightType === "commercial" || flightType === 0;
};

export const getFlightType = (type) =>
({
  // 0: not selected
  1: "pr", // private jet
  2: "commercial",
  pr: 1,
  commercial: 2,
}[normalize(type)] || 0);

export const getUserId = (user) => {
  return user?.hash_id || user?.id;
};

export const getAvatar = (user) => {
  // Precedence:  image > personal_image > avatar
  let image = user?.image;
  if (!image) {
    if (user?.personal_image) {
      image = getBase64Details(user?.personal_image || "").src;
    } else {
      image = user?.avatar;
    }
  }
  return image;
};

export const getFullName = (user) => {
  return `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
};
